import styles from "./style.module.scss";
import Link from "@components/shared/linkNoPrefetch";
import Icon from "./icon";
import { BreadcrumbItem } from "@genericTypes/sharedTypes";
import { getDirection } from "@lib/sharedUtils";
import Head from "next/head";

export default function Breadcrumb({
    arr,
    className,
}: {
    arr: BreadcrumbItem[];
    className?: string;
}) {
    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: `
                        {
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            "itemListElement": [${arr
                                .map((el, index) => {
                                    return `{
                                        "@type": "ListItem",
                                        "position": ${index + 1},
                                        "name": "${el.label}",
                                        "item": "https://several.com${el.link}"
                                    }`;
                                })
                                .join(",")}]
                        }
                    `,
                    }}
                />
            </Head>

            <section className="flex mt-4 capitalize">
                {arr?.map((el, index) => (
                    <div
                        key={index}
                        className={`flex items-baseline ${
                            index > 0 ? "ms-3" : ""
                        }`}
                    >
                        {index > 0 && (
                            <span
                                className={`${
                                    getDirection() === "rtl" ? "rotate-180" : ""
                                }`}
                            >
                                <Icon></Icon>
                            </span>
                        )}
                        {el.isActive && (
                            <Link
                                href={el.link}
                                className={`text-sm  ${
                                    index > 0 ? "ms-3" : ""
                                } ${className ?? ""} ${styles["colorStyle"]}`}
                            >
                                {el.label}
                            </Link>
                        )}
                        {!el.isActive && (
                            <span
                                className={` text-sm ms-3 ${className ?? ""} ${
                                    styles["colorStyle"]
                                }`}
                            >
                                {el.label}
                            </span>
                        )}
                    </div>
                ))}
            </section>
        </>
    );
}
